import {
    useState,
} from 'react';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { Button, Alert, Tab, Tabs, FormCheck } from 'react-bootstrap';
import { useNavigate, useOutletContext } from 'react-router-dom';
import Loader from '../components/Loader';
import { checkError, getCookie } from '../utils/utils';
import { api } from "../services/config"
import axios from 'axios';


function ExportScreen() {
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("Une erreur s'est produite lors de l'exportation des termes");
    const [isLoading, setIsLoading] = useState(false);
    const columnsTerms = {
        "required": {
            "Term_ID": "Term ID",
            "Surface": "Surface"
        },
        "optional": {
            "Language": "Language", "Status": "Status",
            "Head": "Head", "HeadPdty": "Head Productivity", "NHead": "Head N",
            "Expansion": "Expansion", "ExpansionType": "Expansion Type",
            "ExpansionPdty": "Expansion Productivity", "NExpansion": "Expansion N",
            "Words": "Words", "Analysis": "Analysis", "Lemma": "Lemma",
            "PosTagging": "Pos Tagging", "Relevance": "Relevance",
            "Classes": "Classes", "External": "External",
            "Synonyms": "Synonyms", "Translations": "Translations", "QSynonyms": "Quasi-Synonyms",
            "Acronyms": "Acronyms", "Variants": "Variants"
        }
    };
    const columnsClasses = {
        "required": {
            "IdClasse": "IdClasse", "Vedette_Surface": "Vedette Surface",
            "Vedette_Langue": "Vedette Langue"
        },
        "optional": {
            "Termes_lies_Identifiants": "Termes lies Identifiants",
            "Termes_lies_Surfaces": "Termes lies Surfaces", "Termes_lies_Langues": "Termes lies Langues",
            "Hyperonymes": "Hyperonymes", "Classes_associees": "Classes associees",
            "IdExterne": "IdExterne"
        }
    }
    const [type, setType] = useState("terms");
    const [format, setFormat] = useState("tsv");
    const [columns, setColumns] = useState(Object.keys(columnsTerms.required));
    const navigate = useNavigate()
    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState


    const onChangeType = (value) => {

        setType(value);
        if (value === "terms") {
            setColumns(Object.keys(columnsTerms.required));
            setFormat("tsv");
        } else {
            setColumns(Object.keys(columnsClasses.required));
        }
    }

    const onChangeFormat = (e) => {
        setFormat(e.target.value);
    }

    const onChangeColumns = (e) => {
        if (e.target.checked) {
            setColumns([...columns, e.target.value]);
        } else {
            setColumns(columns.filter((column) => column !== e.target.value));
        }
    }


    const onShowSuccessMessage = () => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
        }, 5000)
    };

    const onShowErrorMessage = () => {
        setShowError(true)
        window.setTimeout(() => {
            setShowError(false)
        }, 8000)
    };

    const csrftoken = getCookie('csrftoken');

    async function onClickButton() {
        setIsLoading(true);
        const data = {
            "format": type === "classes" ? (format === "tsv" ? "classes-tsv" : "classes-rdf") : "terms",
            "columns": columns
        }
        await axios.post(
            api.project + projectId + '/export/',
            data,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                },
            }
        )
            .then(checkError)
            .then(() => {
                setIsLoading(false)
                onShowSuccessMessage()
                setMessage(<span> Export des termes en cours, veuillez vérifier la page <span className="link_text" onClick={() => navigate("/tasks/")}>Status des tâches</span> </span>)
            })

            .catch((res) => {
                setIsLoading(false)
                if (res.response && res.response.status === 409) {
                    setErrorMessage("Une tâche en arrière-plan modifie les termes/classes. Les données exportées ne seraient pas consistantes. Veuillez réessayer plus tard.");
                } else {
                    setErrorMessage("Une erreur s'est produite lors de l'exportation des termes");
                }
                onShowErrorMessage();
                console.log(res);
            })

    }

    return (
        <div>
            <div className="container-element d-flex flex-column align-items-center">
                <div className="export_tabs w-50 mt-1">
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={type}
                        onSelect={(k) => onChangeType(k)}
                    >
                        <Tab eventKey="terms" title="Termes">
                            <div className="container text-center mt-5">
                                <h4 className="mb-3">Export des termes</h4>
                                <div className="row justify-content-center">
                                    <div className="col-6 d-flex flex-wrap text-left">
                                        {
                                            Object.entries(columnsTerms.required).map(([key, value]) => (
                                                <div className='col-6'>
                                                    <FormCheck
                                                        key={key}
                                                        type="switch"
                                                        id={key}
                                                        label={value}
                                                        value={key}
                                                        checked={true}
                                                        disabled
                                                    />
                                                </div>
                                            ))
                                        }
                                        {
                                            Object.entries(columnsTerms.optional).map(([key, value]) => (
                                                <div className='col-6'>
                                                    <FormCheck
                                                        key={key}
                                                        type="switch"
                                                        id={key}
                                                        label={value}
                                                        value={key}
                                                        checked={columns.includes(key)}
                                                        onChange={onChangeColumns}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        <Tab eventKey="classes" title="Classes">
                            <div className="container text-center mt-5">
                                <h4 className="mb-3">Export des classes</h4>
                                <FormControl className='pb-2' sx={{ m: 1, minWidth: 120 }} size="small">
                                    <InputLabel id="demo-select-small">Format</InputLabel>
                                    <Select
                                        labelId="classes-format-label"
                                        id="classes-format-select"
                                        value={format}
                                        onChange={onChangeFormat}
                                        label="Format"
                                    >
                                        <MenuItem value={"tsv"}>TSV</MenuItem>
                                        <MenuItem value={"rdf"}>RDF</MenuItem>
                                    </Select>
                                </FormControl>
                                <div className="row justify-content-center">
                                    <div className="col-6 d-flex flex-wrap text-left">
                                        {
                                            Object.entries(columnsClasses.required).map(([key, value]) => (
                                                <div className='col-6'>
                                                    <FormCheck
                                                        key={key}
                                                        type="switch"
                                                        id={key}
                                                        label={value}
                                                        value={key}
                                                        checked={true}
                                                        disabled
                                                    />
                                                </div>
                                            ))
                                        }
                                        {
                                            Object.entries(columnsClasses.optional).map(([key, value]) => (
                                                <div className='col-6'>
                                                    <FormCheck
                                                        key={key}
                                                        type="switch"
                                                        id={key}
                                                        label={value}
                                                        checked={columns.includes(key) && format === "tsv"}
                                                        value={key}
                                                        onChange={onChangeColumns}
                                                        disabled={format === "rdf"}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    </Tabs>

                </div>
                <div className="container text-center mt-5">
                    <Alert className="mx-5" variant="success" show={showSuccess} >
                        Export des termes en cours, veuillez vérifier la page Statut des tâches pour suivre l'avancement de l'export.
                    </Alert>
                    <Alert className="mx-5" variant="danger" show={showError} >
                        {errorMessage}
                    </Alert>
                    {isLoading && <div className="m-2"><Loader>Export des termes ...</Loader></div>}
                    <div className="text-center"><Button className="mt-2" onClick={onClickButton} >Export</Button></div>
                    <p className="m-2  mt-4">{message}</p>
                </div>
            </div>
        </div >
    )
}

export default ExportScreen
